<template>
  <div class="matchUser">
    <el-form-item label="指定用户:" prop="accounts">
      <div class="accounts" style="display: flex">
        <el-upload v-show="false" :action="'#'" :on-success="() => { }" :before-upload="beforeUpload">
          <el-button ref="uploadBtn" v-show="false" :disabled="!canEdit">点击上传</el-button>
        </el-upload>
        <div style="display: flex" @click="upload">
          <el-input placeholder="请选择文件" v-model="fileName" :disabled="true"></el-input>
          <el-button :disabled="!canEdit">导入</el-button>
        </div>
        <el-button @click="exportUser" :disabled="!canEdit">导出</el-button>
        <el-button style="display: flex; margin-left: 20px" @click="previewHandler">查看</el-button>
        <el-button type="text" style="margin-left: 20px" @click="downloadTemplate" v-if="canEdit"><i
            class="el-icon-info"></i>模板下载</el-button>
      </div>
      <span class="extraText">{{ this.text }}</span>
    </el-form-item>
    <el-drawer title="指定用户" :visible.sync="preview" direction="rtl" size="50%" :close="rollbackAccount">
      <div>
        <div style="display: flex; padding: 0 20px 20px 20px">
          <el-input placeholder="请输入手机号" v-model="accountSearch"></el-input>
          <el-button @click="accountFilter" style="margin-left: 10px;"><i class="el-icon-search"></i>查询</el-button>
          <el-button @click="reset"><i class="el-icon-refresh"></i>重置</el-button>
        </div>
        <el-table :data="getCurrentAccounts()" ref="accountTableData" tooltip-effect="dark" border style="width: 100%"
          :key="2">
          <el-table-column sortable prop="name" label="姓名" width="180" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="cellphone" label="手机号" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="valid" label="有效性" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <i class="el-icon-check" v-if="typeof (scope.row.valid) == 'undefined' || scope.row.valid"
                style="color:green">有效</i>
              <i class="el-icon-close" v-else style="color:red">无效</i>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center" fixed="right" v-if="canEdit">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="delAccount(scope)"><i class="el-icon-delete"></i>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <el-pagination background layout="prev, pager, next" @current-change="currentChange" :current-page="current"
            :total="total"></el-pagination>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "matchUser",
  props: {
    label: '',
    value: Array,
    labelWidth: '',
    text: String,
    needConfirm: false,
    disable: false,
  },
  data() {
    return {
      fileName: "",
      preview: false,
      accountInfos: this.value,
      accountInfoBack: JSON.parse(JSON.stringify(this.value)),
      accountSearch: "",
      pageSize: 10,
      current: 1,
      total: 0,
      showTip: this.needConfirm,
      canEdit: !this.disable
    }
  },
  beforeMount() {
    this.accountInfoBack = JSON.parse(JSON.stringify(this.value)).map(i => {
      if (typeof (i.valid) == 'undefined' || i.valid) { i.valid = true; }
      else { i.valid = false; } return i;
    });
  },
  methods: {
    previewHandler() {
      this.current = 1;
      this.preview = true;
      if (!this.accountInfos) {
        this.accountInfos = this.accountInfoBack
        this.getCurrentAccounts()
      }
      // console.log(this.courseWorker.multipleChoices);
    },
    upload() {
      if (!this.canEdit) {
        return;
      }

      if (this.showTip && this.accountInfos && this.accountInfos.length > 0) {
        this.$confirm('此操作在将清空部分学员的学习记录，是否继续？', '提示', {
          confirmButtonText: '确认',
          cancleButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.uploadBtn.$el.click();
        }).catch(() => {
        })
      } else {
        this.$refs.uploadBtn.$el.click();
      }
    },
    beforeUpload(file) {
      let that = this;
      const isSupport =
        file.name.toLowerCase().endsWith(".xls") ||
        file.name.toLowerCase().endsWith(".xlsx");

      if (!isSupport) {
        this.$message.error("仅支持excel文件");
        return false;
      }

      let formData = new FormData();
      formData.append("file", file);
      window.instance.post(window.retailogUrl + "/account/discern", formData).then((res) => {
        let { data } = res.data;
        that.accountInfos = [];
        // console.log(file.name);
        if (res.data.code === 200) {
          this.fileName = file.name;

          that.accountInfos = JSON.parse(JSON.stringify(data));
          // that.ruleForm.accounts = this.accountInfos.filter(i=>i.valid).map((i) => i.account);

          this.$emit('input', this.accountInfos)
          this.$emit('change', this.accountInfos)
          this.total = this.accountInfos.length
          this.accountInfoBack = JSON.parse(JSON.stringify(this.accountInfos));
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      });

      return false;
    },
    async downloadTemplate() {
      let response = await window.instance({
        method: "get",
        responseType: "blob",
        url: window.retailogUrl + '/account/template',
      });

      let fileName = decodeURI(
        response.headers["content-disposition"].split("''")[1]
      );
      let res = response.data;
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    },
    rollbackAccount() {
      this.current = 1;
      this.accountInfos = JSON.parse(JSON.stringify(this.accountInfoBack));
      this.$emit('input', this.accountInfos)
      this.$emit('change', this.accountInfos)
    },
    delAccount(scope) {
      this.accountInfos = this.accountInfos.filter(
        (i) => i.account != scope.row.account
      );
      this.accountInfoBack = JSON.parse(JSON.stringify(this.accountInfos));
      this.$emit('input', this.accountInfos)
      this.$emit('change', this.accountInfos)
      // this.ruleForm.accounts = this.accountInfos.filter(i=>i.valid).map((i) => i.account);
    },
    reset() {
      this.accountSearch = null;
      this.current = 1;
      this.accountFilter();
    },
    accountFilter() {
      if (!this.accountSearch) {
        this.accountInfos = JSON.parse(JSON.stringify(this.accountInfoBack));
      } else {
        this.accountInfos = this.accountInfoBack.filter(
          (i) => i.cellphone.indexOf(this.accountSearch) > -1
        );
      }
      this.total = this.accountInfos.length;
      this.current = 1;
    },
    async exportUser() {
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: window.retailogUrl + "/account/exports",
        data: _.map(this.accountInfos, (account) => (account.cellphone))
      });
    },
    currentChange(index) {
      // 分页
      this.current = index;
      // this.getData();
      this.getCurrentAccounts();
    },
    getCurrentAccounts() {
      const pageSize = this.pageSize
      if (this.accountInfos) {
        return this.accountInfos.slice((this.current - 1) * pageSize, (this.current - 1) * pageSize + pageSize)
      } else {
        return []
      }

    }
  },
  // watch: {
  //   value: function(val, oldVal) {
  //     console.log('用户数据变化', val)
  //     // this.accountInfos = val
  //     // this.total = this.accountInfos.length
  //   }
  // },

  watch: {
    'value': {
      handler(newVal, oldVal) {
        this.accountInfos = newVal
        _.each(this.accountInfos, (account) => {
          if (typeof (account.valid) == 'undefined' || account.valid) { account.valid = true; }
          else { account.valid = false; }
        })
        this.total = this.accountInfos ? this.accountInfos.length : 0
      },
      deep: true,
      immediate: true
    },
    'disable': {
      handler(newVal, oldVal) {
        this.canEdit = !newVal
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    labelStyle() {
      const w = this.labelWidth || '100';
      return {
        width: w + 'px'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .matchUser
    display: flex
    //margin-bottom: 20px
    .label
      text-align: right
      vertical-align: middle
      float: left
      font-size: 14px
      color: #606266
      line-height: 36px
      padding: 0 12px 0 0
      -webkit-box-sizing: border-box
      box-sizing: border-box
      flex-shrink: 0

    .multiPickContent
      margin-top: 4px
      width: 100%
      line-height: 26px
    .paging
      margin: 20px 0 0 10px
    .extraText
      font-size: 14px
      color: #606266
</style>



// WEBPACK FOOTER //
// src/topdoor/components/matchUser.vue